import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  command: {
    '&.MuiButton-text:not(.Mui-disabled):not(.MuiButton-colorInherit)': {
      color: theme.palette.primary.main,
    },
    '&:hover': {
      textDecoration: 'none',
    },
  },
});
